/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UniversalProfileProxy,
  UniversalProfileProxyInterface,
} from "../UniversalProfileProxy";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "operation",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "ContractCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "value",
        type: "bytes",
      },
    ],
    name: "DataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "operation",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Executed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "typeId",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "returnedValue",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "receivedData",
        type: "bytes",
      },
    ],
    name: "UniversalReceiver",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "ValueReceived",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_operation",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "execute",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keys",
        type: "bytes32[]",
      },
    ],
    name: "getData",
    outputs: [
      {
        internalType: "bytes[]",
        name: "values",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "universalProfile",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes",
      },
    ],
    name: "isValidSignature",
    outputs: [
      {
        internalType: "bytes4",
        name: "magicValue",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "_keys",
        type: "bytes32[]",
      },
      {
        internalType: "bytes[]",
        name: "_values",
        type: "bytes[]",
      },
    ],
    name: "setData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_typeId",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "universalReceiver",
    outputs: [
      {
        internalType: "bytes",
        name: "returnValue",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class UniversalProfileProxy__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniversalProfileProxy> {
    return super.deploy(overrides || {}) as Promise<UniversalProfileProxy>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): UniversalProfileProxy {
    return super.attach(address) as UniversalProfileProxy;
  }
  connect(signer: Signer): UniversalProfileProxy__factory {
    return super.connect(signer) as UniversalProfileProxy__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniversalProfileProxyInterface {
    return new utils.Interface(_abi) as UniversalProfileProxyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniversalProfileProxy {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UniversalProfileProxy;
  }
}
